const MONTHLY_GOAL = 141.6;

const defaultStats = () => ({
  goal: MONTHLY_GOAL,
  raised: 0,
  progress: 0,
  month: new Date().toISOString().slice(0, 7),
});

export async function fetchFundingStats() {
  try {
    const res = await fetch('/api/funding');
    if (!res.ok) throw new Error('Failed to load funding stats');
    const data = await res.json();
    return {
      goal: Number(data?.goal) || MONTHLY_GOAL,
      raised: Number(data?.raised) || 0,
      progress: Number(data?.progress) || 0,
      month: data?.month || defaultStats().month,
    };
  } catch (err) {
    console.warn('fetchFundingStats failed:', err);
    return defaultStats();
  }
}

/**
 * DEPRECATED: Manual donation recording is now disabled.
 * Donations are now automatically verified via gateway webhooks.
 * This function is kept as a stub for compatibility but will throw.
 */
export async function recordDonation() {
  throw new Error('Manual donation recording is disabled. The funding meter will update automatically once your payment is confirmed by the provider.');
}

export { MONTHLY_GOAL };
